const diYu = [
  '北京',
  '上海',
  '广州',
  '深圳',
  '香港',
  '成都',
  '杭州',
  '重庆',
  '武汉',
  '苏州',
  '西安',
  '天津',
  '南京',
  '郑州',
  '长沙',
  '沈阳',
  '青岛',
  '宁波',
  '东莞',
  '无锡',
  '昆明',
  '大连',
  '厦门',
  '合肥',
  '佛山',
  '福州',
  '哈尔滨',
  '济南',
  '温州',
  '长春',
  '石家庄',
  '唐山',
  '秦皇岛',
  '邯郸',
  '邢台',
  '保定',
  '张家口',
  '承德',
  '沧州',
  '廊坊',
  '衡水',
  '太原',
  '大同',
  '阳泉',
  '长治',
  '晋城',
  '朔州',
  '晋中',
  '运城',
  '忻州',
  '临汾',
  '吕梁',
  '呼和浩特',
  '包头',
  '乌海',
  '赤峰',
  '通辽',
  '鄂尔多斯',
  '呼伦贝尔',
  '巴彦淖尔',
  '乌兰察布',
  '兴安盟',
  '锡林郭勒盟',
  '阿拉善盟',
  '鞍山',
  '抚顺',
  '本溪',
  '丹东',
  '锦州',
  '营口',
  '阜新',
  '辽阳',
  '盘锦',
  '朝阳',
  '葫芦岛',
  '吉林',
  '四平',
  '辽源',
  '通化',
  '白山',
  '松原',
  '白城',
  '延边',
  '齐齐哈尔',
  '鸡西',
  '鹤岗',
  '双鸭山',
  '大庆',
  '伊春',
  '佳木斯',
  '七台河',
  '牡丹江',
  '黑河',
  '绥化',
  '大兴安岭地区',
  '徐州',
  '常州',
  '南通',
  '连云港',
  '淮安',
  '盐城',
  '扬州',
  '镇江',
  '泰州',
  '宿迁',
  '嘉兴',
  '湖州',
  '绍兴',
  '金华',
  '衢州',
  '舟山',
  '台州',
  '丽水',
  '芜湖',
  '蚌埠',
  '淮南',
  '马鞍山',
  '淮北',
  '铜陵',
  '安庆',
  '黄山',
  '滁州',
  '阜阳',
  '宿州',
  '六安',
  '亳州',
  '池州',
  '宣城',
  '莆田',
  '三明',
  '泉州',
  '漳州',
  '南平',
  '龙岩',
  '宁德',
  '南昌',
  '景德镇',
  '萍乡',
  '九江',
  '新余',
  '鹰潭',
  '赣州',
  '吉安',
  '宜春',
  '抚州',
  '上饶',
  '淄博',
  '枣庄',
  '东营',
  '烟台',
  '潍坊',
  '济宁',
  '泰安',
  '威海',
  '日照',
  '莱芜',
  '临沂',
  '德州',
  '聊城',
  '滨州',
  '菏泽',
  '开封',
  '洛阳',
  '平顶山',
  '安阳',
  '鹤壁',
  '新乡',
  '焦作',
  '济源',
  '濮阳',
  '许昌',
  '漯河',
  '三门峡',
  '南阳',
  '商丘',
  '信阳',
  '周口',
  '驻马店',
  '黄石',
  '十堰',
  '宜昌',
  '襄阳',
  '鄂州',
  '荆门',
  '孝感',
  '荆州',
  '黄冈',
  '咸宁',
  '随州',
  '恩施',
  '仙桃',
  '潜江',
  '天门',
  '神农架林区',
  '株洲',
  '湘潭',
  '衡阳',
  '邵阳',
  '岳阳',
  '常德',
  '张家界',
  '益阳',
  '郴州',
  '永州',
  '怀化',
  '娄底',
  '湘西',
  '韶关',
  '珠海',
  '汕头',
  '江门',
  '湛江',
  '茂名',
  '肇庆',
  '惠州',
  '梅州',
  '汕尾',
  '河源',
  '阳江',
  '清远',
  '中山',
  '东沙群岛',
  '潮州',
  '揭阳',
  '云浮',
  '南宁',
  '柳州',
  '桂林',
  '梧州',
  '北海',
  '防城港',
  '钦州',
  '贵港',
  '玉林',
  '百色',
  '贺州',
  '河池',
  '来宾',
  '崇左',
  '海口',
  '三亚',
  '三沙',
  '五指山',
  '琼海',
  '儋州',
  '文昌',
  '万宁',
  '东方',
  '定安县',
  '屯昌县',
  '澄迈县',
  '临高县',
  '白沙',
  '昌江',
  '乐东',
  '陵水',
  '保亭',
  '琼中',
  '自贡',
  '攀枝花',
  '泸州',
  '德阳',
  '绵阳',
  '广元',
  '遂宁',
  '内江',
  '乐山',
  '南充',
  '眉山',
  '宜宾',
  '广安',
  '达州',
  '雅安',
  '巴中',
  '资阳',
  '阿坝',
  '甘孜',
  '凉山',
  '贵阳',
  '六盘水',
  '遵义',
  '安顺',
  '铜仁',
  '黔西南',
  '毕节',
  '黔东南',
  '黔南',
  '曲靖',
  '玉溪',
  '保山',
  '昭通',
  '丽江',
  '普洱',
  '临沧',
  '楚雄',
  '红河',
  '文山',
  '西双版纳',
  '大理',
  '德宏',
  '怒江',
  '迪庆',
  '拉萨',
  '昌都地区',
  '山南地区',
  '日喀则地区',
  '那曲地区',
  '阿里地区',
  '林芝地区',
  '铜川',
  '宝鸡',
  '咸阳',
  '渭南',
  '延安',
  '汉中',
  '榆林',
  '安康',
  '商洛',
  '兰州',
  '嘉峪关',
  '金昌',
  '白银',
  '天水',
  '武威',
  '张掖',
  '平凉',
  '酒泉',
  '庆阳',
  '定西',
  '陇南',
  '临夏',
  '甘南',
  '西宁',
  '海东',
  '海北',
  '黄南',
  '海南',
  '果洛',
  '玉树',
  '海西',
  '银川',
  '石嘴山',
  '吴忠',
  '固原',
  '中卫',
  '乌鲁木齐',
  '克拉玛依',
  '吐鲁番地区',
  '哈密地区',
  '昌吉',
  '博尔塔拉',
  '巴音郭楞',
  '阿克苏地区',
  '克孜勒苏柯尔克孜自治州',
  '喀什地区',
  '和田地区',
  '伊犁',
  '塔城地区',
  '阿勒泰地区',
  '石河子',
  '阿拉尔',
  '图木舒克',
  '五家渠',
  '台北',
  '高雄',
  '台南',
  '台中',
  '金门县',
  '南投县',
  '基隆',
  '新竹',
  '嘉义',
  '新北',
  '宜兰县',
  '新竹县',
  '桃园县',
  '苗栗县',
  '彰化县',
  '嘉义县',
  '云林县',
  '屏东县',
  '台东县',
  '花莲县',
  '澎湖县',
  '连江县',
  '新界',
  '澳门',
  '离岛',
  '韩国','日本','马来西亚','新加坡','加拿大','美国','澳大利亚','新西兰','芬兰','瑞典','挪威','丹麦','白俄罗斯','俄罗斯','乌克兰','德国','瑞士','英国','爱尔兰','荷兰','法国','意大利','西班牙'
]

export { diYu }
